import { Component, OnInit, Input } from '@angular/core';
import { AdminQuestion, QuestionType } from '../../../models/questions';

@Component({
  selector: 'app-question-text',
  templateUrl: './question-text.component.html',
  styleUrls: ['./question-text.component.scss']
})
export class QuestionTextComponent implements OnInit {
  @Input() question: AdminQuestion = {};

  ngOnInit() { }

  getIsNumberForm(): boolean {
  return  this.question.answerType === QuestionType.Number;
  }
}
